import React, { useState, useEffect, useContext } from "react";
import { CCollapse, CLink } from "@coreui/react";
import { Field, Form, Formik } from "formik";
import config from "../../config/config";
import axios from "axios";

import { toastError, toastSuccess } from "../../common/Toast";
import Loader from "../Loader/Loader";
import { AppContext } from "../../context/AppContext";

const ManageSaleModule = ({ searchQuery, POSEditChange }) => {
    const { fetchData } = useContext(AppContext);
  const [POSEdit, setPOSEdit] = useState(false);
  const [formValues, setFormValues] = useState({ POSEdit: 0, SaleEdit: 0 });
  const [prevFormValues, setPrevFormValues] = useState({ POSEdit: 0, SaleEdit: 0 });
  
  const [loading, setLoading] = useState(false);

  const token = localStorage.getItem("Token");

  const handleSubmit = async (values) => {
    const formArray = [
      { AppConfigkey: "POSEdit", AppConfigvalue: values.POSEdit },
      { AppConfigkey: "SaleEdit", AppConfigvalue: values.SaleEdit },
    ];

    // Check if values have changed
      if (
        prevFormValues.POSEdit !== values.POSEdit &&
        prevFormValues.SaleEdit !== values.SaleEdit
      ) {
        localStorage.removeItem("saleDraft");
        localStorage.removeItem("DeliveryDraft");
        localStorage.removeItem("posDraft");
      }

    const jsonString = JSON.stringify({ StoreConfig: formArray });

    setLoading(true);
    try {
      const response = await axios.post(
        `${config.storeConfigBaseUrl}/storeconfig/upsert`,
        { type: "PERMISSION", storeconfigxml: jsonString },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      );

      if (response.data.ResponseCode === "SUCCESS" && response.data.ResponseID > 0) {
        toastSuccess("Record has been added!");
        fetchData();
      } else {
        toastError("Something went wrong");
      }
    } catch (error) {
      toastError("Failed to save data. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleChange = ({ target: { name, checked } }) => {
    setFormValues((prev) => {
      const newValues = { ...prev, [name]: checked ? 1 : 0 };

      // Ensure only one input is selected at a time
      if (newValues.POSEdit == 1 && newValues.SaleEdit == 1) {
        if (name === "POSEdit") {
          newValues.SaleEdit = 0;
        } else {
          newValues.POSEdit = 0;
        }
      }

      // Ensure at least one input is always selected
      if (newValues.POSEdit == 0 && newValues.SaleEdit == 0) {
        newValues[name] = 1;
      }

      return newValues;
    });
  };

  const filteredData = [
    {
      name: "POS Layout",
      fieldName: "POSEdit",
    },
    {
      name: "Invoice Layout",
      fieldName: "SaleEdit",
    },
  ].filter((item) =>
    item.name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const renderFormFields = () => {
    // fetchData();
    return filteredData.map(({ name, fieldName }) => (
      <div
        key={fieldName}
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "space-between",
          marginTop: "10px",
        }}
      >
        <label className="col-form-label" style={{ fontSize: "15px" }}>
          {name}
        </label>
        <div style={{ width: "53%" }}>
          {/* Toggle Switch */}
          <label className="switch">
            <input
              type="checkbox"
              name={fieldName}
              checked={formValues[fieldName] === 1} // Ensure number comparison
              onChange={handleChange}
            />
            <span className="slider round"></span>
          </label>
        </div>
      </div>
    ));
  };

  useEffect(() => {
    setLoading(true);

    axios
      .get(
        `${config.storeConfigBaseUrl}/storeconfig/getallconfig?type=PERMISSION`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((response) => {
        const responseData = response?.data?.ResponseData;

        if (responseData && Array.isArray(responseData)) {
          const updatedFormValues = responseData.reduce(
            (acc, data) => {
              acc[data.AppConfigkey] = Number(data.AppConfigvalue) == 1 ? 1 : 0;
              return acc;
            },
            { POSEdit: 0, SaleEdit: 0 } // Default values if missing
          );

          // Ensure at least one input is always selected
          if (updatedFormValues.POSEdit == 0 && updatedFormValues.SaleEdit == 0) {
            updatedFormValues.POSEdit = 1;
          }

          console.log(updatedFormValues,"updatedFormValuescheck");

          setFormValues(updatedFormValues);
          setPrevFormValues(updatedFormValues);
        } else {
          toastError("Invalid configuration data received.");
        }
      })
      .catch((error) => {
        console.error("Error fetching configuration data:", error);
        toastError("Failed to fetch configuration data. Please try again.");
      })
      .finally(() => setLoading(false));
  }, []);

  return (
    <>
      <Loader loading={loading} />
      <div className="card">
        <div
          className="card-header"
          style={{ padding: "0px", marginTop: "16px", marginLeft: "18px" }}
        >
          <h5 className="card-title">
            <CLink
              style={{ color: "var(--primary-main-color)" }}
              onClick={() => setPOSEdit((prev) => !prev)}
            >
              Manage Sale Module
            </CLink>
          </h5>
        </div>
        <CCollapse visible={POSEdit || POSEditChange}>
          <div className="card-body">
            <Formik
              initialValues={formValues}
              onSubmit={handleSubmit}
              enableReinitialize
            >
              {() => (
                <Form>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                      width: "40%",
                    }}
                  >
                    {renderFormFields()}
                  </div>
                  <button
                    type="submit"
                    className="btn btn-sm btn-primary pull-right mb-3"
                  >
                    Save
                  </button>
                </Form>
              )}
            </Formik>
          </div>
        </CCollapse>
      </div>
    </>
  );
};

export default ManageSaleModule;
